var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Redirect',{attrs:{"url":_vm.url,"tiempoEspera":_vm.tiempoEspera}})
}
var staticRenderFns = []

export { render, staticRenderFns }